export default __webpack_public_path__ + "ch-how-to-play.icon-fa91b4ca8b72992d64568eda60348ffb.png";